import axios from 'axios'
import { capiCreator } from 'tr-components/redux/CallApiMiddlewareActionCreator'

const FETCH_GROUPS = 'groups/FETCH_GROUPS'
const FETCH_GROUPS_SUCCESS = 'groups/FETCH_GROUPS_SUCCESS'
const FETCH_GROUPS_FAIL = 'groups/FETCH_GROUPS_FAIL'

const FETCH_GROUP = 'groups/FETCH_GROUP'
const FETCH_GROUP_SUCCESS = 'groups/FETCH_GROUP_SUCCESS'
const FETCH_GROUP_FAIL = 'groups/FETCH_GROUP_FAIL'

const PUT_GROUP = 'groups/PUT_GROUP'
const PUT_GROUP_SUCCESS = 'groups/PUT_GROUP_SUCCESS'
const PUT_GROUP_FAIL = 'groups/PUT_GROUP_FAIL'

const SET_SNACKBAR_MESSAGE = 'groups/SET_SNACKBAR_MESSAGE'
const CLEAR_SNACKBAR_MESSAGE = 'groups/CLEAR_SNACKBAR_MESSAGE'

export const ACTIONS = {
  FETCH_GROUPS,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAIL,
  FETCH_GROUP,
  FETCH_GROUP_SUCCESS,
  FETCH_GROUP_FAIL,
  PUT_GROUP,
  PUT_GROUP_SUCCESS,
  PUT_GROUP_FAIL,
  SET_SNACKBAR_MESSAGE,
  CLEAR_SNACKBAR_MESSAGE
}

export const initialState = {
  groups: [],
  editingGroup: null,
  fetchingGroups: false,
  fetchGroupsError: null,
  savingGroup: false,
  saveGroupError: null,
  fetchingGroup: false,
  fetchGroupError: null,
  snackbarMessage: null
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_GROUPS:
      return {
        ...state,
        fetchingGroups: true,
        fetchGroupsError: null
      }
    case FETCH_GROUPS_SUCCESS:
      return {
        ...state,
        fetchingGroups: false,
        groups: payload
      }
    case FETCH_GROUPS_FAIL:
      return {
        ...state,
        fetchingGroups: false,
        fetchGroupsError: payload
      }
    case PUT_GROUP:
      return {
        ...state,
        savingGroup: true,
        saveGroupError: null
      }
    case PUT_GROUP_SUCCESS:
      return {
        ...state,
        savingGroup: false
      }
    case PUT_GROUP_FAIL:
      return {
        ...state,
        savingGroup: false,
        saveGroupError: payload
      }
    case FETCH_GROUP:
      return {
        ...state,
        fetchingGroup: true,
        fetchGroupError: null
      }
    case FETCH_GROUP_SUCCESS:
      return {
        ...state,
        fetchingGroup: false,
        editingGroup: payload
      }
    case FETCH_GROUP_FAIL:
      return {
        ...state,
        fetchingGroup: false,
        fetchGroupError: payload
      }
    case SET_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: payload
      }
    case CLEAR_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: null
      }
    default:
      return state
  }
}

export default reducer

export const setSnackBarMessage = (message) => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: message
})

export const clearSnackbarMessage = () => ({
  type: CLEAR_SNACKBAR_MESSAGE
})

export const saveOrUpdateGroup = (group) =>
  capiCreator(PUT_GROUP, PUT_GROUP_SUCCESS, PUT_GROUP_FAIL, () =>
    axios.patch(`/positionGroups/${group.id}`, group, { headers: { 'x-api': 'positions_v1' } })
  )

export const fetchGroup = (id) =>
  capiCreator(FETCH_GROUP, FETCH_GROUP_SUCCESS, FETCH_GROUP_FAIL, () =>
    axios.get(`/positionGroups/${id}`, { headers: { 'x-api': 'positions_v1' } })
  )

export const fetchGroups = () =>
  capiCreator(FETCH_GROUPS, FETCH_GROUPS_SUCCESS, FETCH_GROUPS_FAIL, () =>
    axios.get('/positionGroups', { headers: { 'x-api': 'positions_v1' } })
  )



// WEBPACK FOOTER //
// ./src/modules/Positions/reducers/groups.js